import React from 'react'
import { CFView, CFImage, DefaultScreen, MobileScreen } from 'components'
import { orderPickupButton } from 'images'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/jwtXW2Bc6tUEEYtcnIIt/locations/MvLV4OUJjaddWhfyWwXM'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <a href={orderingUrl}>
          <CFView hover>
            <CFImage src={orderPickupButton} maxWidth="300px" alt="About" />
          </CFView>
        </a>
      </MobileScreen>
      <DefaultScreen>
        <a href={orderingUrl}>
          <CFView hover>
            <CFImage src={orderPickupButton} maxWidth="460px" alt="About" />
          </CFView>
        </a>
      </DefaultScreen>
    </CFView>
  )
}
